import { ColumnSortType, TableColumnTypes } from '../../model/table.model';


export const tableHeaders = [
  {
    value: 'primary',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.CHECKBOX,
    className: 'table-checkbox'
  },
  {
    value: 'ttn',
    sort: ColumnSortType.NONE,
    name: 'ТТН',
    type: TableColumnTypes.TEXT_COPY,
    className: 'table-header',
  },
  {
    value: 'status',
    sort: ColumnSortType.NONE,
    name: 'status',
    type: TableColumnTypes.UKR_POSHTA_STATUS,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'ukr_status',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.TEXT_TRANSLATE,
    className: 'table-header',
  },
  {
    value: 'phone',
    sort: ColumnSortType.NONE,
    name: 'phone',
    type: TableColumnTypes.PHONE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'comments',
    sort: ColumnSortType.NONE,
    name: 'comment',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'created_at',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'updated_at',
    sort: ColumnSortType.NONE,
    name: 'updated_at',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        {icon: 'edit', label: 'edit', value: 'EDIT'},
        {icon: 'delete', label: 'delete', value: 'DELETE'},
      ],
    translate: true,
  },
];
